module.exports = "<!-- begin:: Page -->\r\n<router-outlet></router-outlet>\r\n<!-- end:: Page -->\r\n<!-- <app-quick-sidebar></app-quick-sidebar> -->\r\n<app-scroll-top></app-scroll-top>\r\n<!-- <app-tooltips></app-tooltips> -->\r\n<!--begin::Base Scripts -->\r\n<!--end::Base Scripts -->\r\n<!--begin::Page Vendors -->\r\n<!--end::Page Vendors -->\r\n<!--begin::Page Snippets -->\r\n<!--end::Page Snippets -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main